import {Component, Input} from '@angular/core';
import {fabWyliczPozniejAnimationTriggrer} from './fab-wylicz-pozniej.component.animations';
import {Store} from '@ngrx/store';
import {kliknietoWyliczPozniej} from '../../../../samoobsluga/proces-uszkodzen/majatek/dom/ekran-podsumowania/store/ekran-podsumowania.actions';

export enum FabState {
  inactive = 'inactive',
  active = 'active',
}

@Component({
  selector: 'fab-wylicz-pozniej',
  templateUrl: './fab-wylicz-pozniej.component.html',
  styleUrls: ['./fab-wylicz-pozniej.component.scss'],
  animations: fabWyliczPozniejAnimationTriggrer
})
export class FabWyliczPozniejComponent {

  @Input()
  correlationId!: string;

  protected readonly FabState = FabState;
  state = FabState.inactive;

  constructor(private store: Store) {}

  toggle = () => this.state = FabState.inactive === this.state ? FabState.active : FabState.inactive;
  wyslijLink = () => this.store.dispatch(kliknietoWyliczPozniej({correlationId: this.correlationId}));

}
